import React from 'react';
import styled from 'styled-components';
import { FixRequiredSelect } from 'components';
import BaseSelect from 'react-select';

export const Container = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
  justify-content: center;
  position: relative;
  width: 100%;
`;

export const Title = styled.h3`
  color: var(--blue);
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.75rem;
  text-align: center;
  width: 100%;
`;

export const Card = styled.div`
  background-color: var(--light-blue);
  border-radius: 2px;
  box-shadow: 0px 6px 20px rgba(196, 196, 196, 0.4);
  display: flex;
  flex-direction: column;
  font-weight: 300;
  gap: 1.75rem;
  max-width: 575px;
  padding: 3.875rem 1.75rem 2.75rem 1.75rem;
  position: relative;
  width: 100%;
`;

export const Label = styled.label`
  align-items: center;
  color: var(--blue);
  display: flex;
  font-size: 0.925rem;
  font-weight: 300;
  line-height: 1.125rem;
  margin-bottom: 0.1rem;
`;

function FormSelect(props) {
  return (
    <FixRequiredSelect
      {...props}
      SelectComponent={BaseSelect}
      options={props.options}
    />
  );
}

export { FormSelect };
